import { GET_INTERNATIONAL_FREIGHT_REQUEST, GET_INTERNATIONAL_FREIGHT_SUCCESS, GET_INTERNATIONAL_FREIGHT_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalFreight = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_FREIGHT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalFreight`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_FREIGHT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_FREIGHT_ERROR,
                payload: error.response,
            });
        })
}

